import api from '../api';
const apiUrl = process.env.REACT_APP_AUTH_API_URL;

const getAllFilesFromProject = async (projectId, keycloakToken) => {
    try {
        const response = await api.get(`${apiUrl}/knowledge-base/${projectId}`, {
            headers: {
                'Authorization': `Bearer ${keycloakToken}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error getting all files from project:', error);
        throw new Error(error?.response?.data?.message || 'Erro ao buscar arquivos do projeto.');
    }
}

const getFileById = async (fileId, keycloakToken) => {
    try {
        const response = await api.get(`${apiUrl}/knowledge-base/asset/${fileId}`, {
            headers: {
                'Authorization': `Bearer ${keycloakToken}`,
            },
        });

        return response.data;
    }
    catch (error) {
        console.error('Error getting file by id:', error);
        throw new Error(error?.response?.data?.message || 'Erro ao buscar arquivo.');
    }
}

const uploadFile = async (file, projectId, keycloakToken) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        
        const response = await api.post(`${apiUrl}/knowledge-base/${projectId}`, formData, {
            headers: {
                'Authorization': `Bearer ${keycloakToken}`,
            },
        });
        
        return response.data;
    } catch (error) {
        console.error('Error uploading file:', error);
        throw new Error(error?.response?.data?.message || 'Erro ao fazer upload do arquivo.');
    }
}

const renameFile = async (fileId, newName, keycloakToken) => {
    try {
        const response = await api.put(`${apiUrl}/knowledge-base/asset/${fileId}`, { name: newName }, {
            headers: {
                'Authorization': `Bearer ${keycloakToken}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error renaming file:', error);
        throw new Error(error?.response?.data?.message || 'Erro ao renomear arquivo.');
    }
}

const deleteFile = async (fileId, keycloakToken) => {
    try {
        const response = await api.delete(`${apiUrl}/knowledge-base/asset/${fileId}`, {
            headers: {
                'Authorization': `Bearer ${keycloakToken}`,
            },
        });
        
        return response.data;
    } catch (error) {
        console.error('Error uploading file:', error);
        throw new Error(error?.response?.data?.message || 'Erro ao  do arquivo.');
    }
}

export default { uploadFile, renameFile, getAllFilesFromProject, deleteFile, getFileById };